import { useEffect, useState } from 'react'
import { isHasTips } from 'lib/ie-version'
import { setPageOffset } from 'Components/hooks/use-page-offset'

// 是否需要添加顶部浏览器升级提示
function useHasTips() {
  const [value, setValue] = useState(false)

  useEffect(() => {
    const value = isHasTips()
    if (value) {
      setValue(true)
      setPageOffset({ top: 52 })
    }
  }, [])

  return value
}

export default useHasTips
